var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Tooltip from '@/components/Tooltip.vue';
let SelectedLabelFilter = class SelectedLabelFilter extends Vue {
    removeSelectedFilter() {
        return true;
    }
};
__decorate([
    Prop({ default: '' })
], SelectedLabelFilter.prototype, "maxWidth", void 0);
__decorate([
    Prop({ default: '' })
], SelectedLabelFilter.prototype, "labelMessage", void 0);
__decorate([
    Prop({ default: false })
], SelectedLabelFilter.prototype, "outline", void 0);
__decorate([
    Prop({ default: '' })
], SelectedLabelFilter.prototype, "tooltipMessage", void 0);
__decorate([
    Prop({ default: 'primary' })
], SelectedLabelFilter.prototype, "bgColor", void 0);
__decorate([
    Prop({ default: 'C8F2FC' })
], SelectedLabelFilter.prototype, "bgColorChip", void 0);
__decorate([
    Emit('removeSelectedFilter')
], SelectedLabelFilter.prototype, "removeSelectedFilter", null);
SelectedLabelFilter = __decorate([
    Component({
        components: {
            Tooltip,
        },
    })
], SelectedLabelFilter);
export default SelectedLabelFilter;
